module.exports = "/076c958321237351e457a25f1551005dcff1e8fc/0a802c4759154178410d9806072b1e8e.svg";